import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import Breadcrumb from 'lowcomp/plugins/blog/common/blog-breadcrumb';
import { LOCALEMAP } from './config';
import './index.scss';

const hostName = process.env.NEXT_PUBLIC_WEB_HOST;

export default function BlogBreadcrumb({ pageModel = 'blog', title = '' }: { pageModel: string; title: string }) {
    const { locale = 'us' } = useRouter();
    const lang = LOCALEMAP[locale as keyof typeof LOCALEMAP] || LOCALEMAP.us;

    const modelMap = {
        blog: lang.Blog,
    };

    const frontNavList = [
        {
            title: lang.Home,
            link: `${hostName}/${locale}`,
        },
        {
            title: modelMap[pageModel as keyof typeof modelMap] || modelMap.blog,
            link: `${hostName}/${locale}/${pageModel}`,
        },
    ];

    const endNavList = !!title
        ? [
              {
                  title: title || '',
              },
          ]
        : [];

    const finalNvList = [...frontNavList, ...endNavList];

    return (
        <div className="bread-crumb-box">
            <Breadcrumb navList={finalNvList} />
        </div>
    );
}
